<template>
  <div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <multiselect
            v-model="selectedHeaders"
            :options="headers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par colonne"
            label="text"
            track-by="text"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Colonnes' : 'Colonne' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div
          class="col-md-6 col-lg-8 text-md-right"
          v-if="currentSession.statut !== 2 && currentSession.statut !== 5"
        >
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: 'rh_formation_session_show_participation-add',
                  params: { id: currentSession.id },
                })
                .catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Ajout de participants
          </button>

          <button
            type="button"
            class="btn btn-success ml-4"
            @click.prevent="accepterAllSelection"
            v-show="isSelect"
          >
            <i class="fa fa-thumbs-up"></i>
            Acceptée
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="refuserAllSelection"
            v-show="isSelect"
          >
            <i class="fa fa-thumbs-down"></i>
            Refusée
          </button>

          <button
            type="button"
            class="btn btn-warning ml-4"
            @click.prevent="reinitialiserAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-hourglass"></i>
            Mettre en attente
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            :currentSession="currentSession"
            :headers="selectedHeaders"
            ref="datatable"
            @onSelect="onSelectRows"
            @onAccepter="accepterRows"
            @onRefuser="refuserRows"
            @onReinitialiser="reinitialiserRows"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './DataTable.vue';
import URL from '@/http/rh/formation/session-participation';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isSelect: false,
      selectedHeaders: [],
      headers: [
        {
          text: 'Prénom',
          align: 'start',
          sortable: true,
          value: 'prenom',
        },
        {
          text: 'Nom',
          align: 'start',
          sortable: true,
          value: 'nom',
        },
        {
          text: 'Matricule',
          align: 'start',
          sortable: true,
          value: 'matricule',
        },
        {
          text: 'Email principal',
          align: 'start',
          sortable: true,
          value: 'email_principal',
        },
        {
          text: 'Téléphone',
          align: 'start',
          sortable: true,
          value: 'telephone',
        },
        {
          text: 'Réponse',
          align: 'start',
          sortable: true,
          value: 'reponse',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('formationSession', ['currentSession']),
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
    'currentSession.statut': {
      immediate: true,
      handler(val) {
        let index = window._.findIndex(
          this.headers,
          (h) => h.text === 'Action'
        );

        if (index >= 0) {
          if (val === 2 || val === 5) {
            this.headers.splice(index, 1);
          }
        } else {
          if (val !== 2 && val !== 5) {
            this.headers.push({
              text: 'Action',
              align: 'center',
              sortable: false,
              value: 'id',
            });
          }
        }
      },
    },
  },
  components: {
    DataTable,
  },
  methods: {
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    accepterAllSelection() {
      this.accepterRows(this.$refs.datatable.idsRowsSelected);
    },
    refuserAllSelection() {
      this.refuserRows(this.$refs.datatable.idsRowsSelected);
    },
    reinitialiserAllSelection() {
      this.reinitialiserRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    accepterRows(ids) {
      if (ids && ids.length > 0) {
        console.log(ids);
        this.showConfirmValidation().then((result) => {
          if (result.value) {
            window.axios
              .put(URL.ACCEPTER, {
                ids: ids,
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
    refuserRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmValidation().then((result) => {
          if (result.value) {
            window.axios
              .put(URL.REFUSER, {
                ids: ids,
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
    reinitialiserRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmValidation().then((result) => {
          if (result.value) {
            window.axios
              .put(URL.REINITIALISER, {
                ids: ids,
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.SESSION_PARTICIPATION, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
